<template>
    <div class="ut-container-lg ut-pt-10">
        <div v-if="agentIsLoaded && userIsLoaded">
           
           <div class="page-heading">
                <h1>File Upload - Prospecting</h1>
            </div>
            <div>
                <vue-dropzone class="ut-mr-5 "
                ref="myVueDropzone"
                :use-custom-slot="true"
                id="dropzone"
                :options="options" 
                :destroyDropzone="true"
                :awss3="awss3"
                v-on:vdropzone-s3-upload-error="s3UploadError"
                v-on:vdropzone-success="dropzoneSuccess"
                v-on:vdropzone-sending="sending"
                >
                 <div class="dz-message" data-dz-message>
                     <div>Drop file here to upload</div>
                     <div class="ut-text-xs">(Allowed types: csv)</div>
                    </div>
                </vue-dropzone>
            </div>
            <info-card
            class="ut-mt-4"
            v-if="isSuccess"
            :info="success"
            />
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from 'axios'
import InfoCard from '@/components/Cards/InfoCard.vue';
export default {
  name: 'ProspectingFileUpload',
  components: {
    vueDropzone: vue2Dropzone,
    InfoCard,
  },
  props: {
    ak: String,
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      user: state => state.userStore.user,
    }),
    agentIsLoaded() {
      return this.agent && this.agent.key;
    },
    userIsLoaded() {
        return this.user && this.user.key;
    },
    awss3() {
        return {
            signingURL: (f) => {return `${process.env.VUE_APP_API_URL}/FileStorageREST/s3-signed-url?filename=${f.name}&service=Prospecting`},
            headers: {},
            params : {userid: this.user.id},
            sendFileToServer : false,
            withCredentials: false
        }
    }
  },
  data() {
      //    dictDefaultMessage: "Drop file here to upload",
    return {
      options: {
        method: "PUT",
        acceptedFiles: 'text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    
        maxFilesize: 25,
                
      },
      success: "File Uploaded Successfully",
      isSuccess: false,
      fileName: null
    }
  },
  methods: {
// Fired AFTER a file is successfully uploaded to S3
    dropzoneSuccess: function ({s3Url}, res) {

      const parser = document.createElement('a');
      parser.href = s3Url;

      const url = parser.origin + parser.pathname;

      // upload the api here with the url

      const bodyFormData = new FormData();
      bodyFormData.append('agentkey', this.agent.key);
      bodyFormData.append('uploadname', 'Prospector Pro - Data');
      bodyFormData.append('uploadtypeid', 3);
      bodyFormData.append('userkey', this.user.key);
      bodyFormData.append('filelocation', url);

      axios.post(`${process.env.VUE_APP_API_URL}/FileStorageREST/file-upload-data`, bodyFormData)
      .then((response) => {
        this.isSuccess = true;

        setTimeout(() => {
            this.isSuccess = false;
        }, 2500);

        //send an email
        
        const emailBody = `${this.agent.name} from ${this.agent.agencyname} has uploaded a file. \nFilename: ${this.fileName}, \nLocation: ${url}`;
        const bodyEmailFormData = new FormData();
        bodyEmailFormData.append('toemail', process.env.VUE_APP_PROSPECTIONG_EMAIL);
        bodyEmailFormData.append('toname', 'Openagent');
        bodyEmailFormData.append('emailbody', emailBody);
        bodyEmailFormData.append('emailsubject', 'Prospector Pro - New file upload');
        bodyEmailFormData.append('mandriltemplate', 'template-generic-email-indigo');
        

        axios.post(`${process.env.VUE_APP_API_URL}/outboundcommsrest/send-email-generic`, bodyEmailFormData)
        .then((res) => {
            // console.table(res);
        })



      })
      .catch(function (error) {
        console.log(error);
      });

    },
    s3UploadError(errorMessage){
       // console.log(errorMessage);
    },
    sending(file){
        this.fileName = file.name;
        if (!file.accepted) {
            // abort doesn't work. Setting the timeout is the only thing I've found that cancels the s3 request. 
            file.xhr.timeout = 1;
        }
    },

  }

}


</script>
<style scoped lang="scss">
</style>